import { render, staticRenderFns } from "./authentification.vue?vue&type=template&id=53c41e0f&scoped=true"
import script from "./authentification.vue?vue&type=script&lang=js"
export * from "./authentification.vue?vue&type=script&lang=js"
import style0 from "./authentification.vue?vue&type=style&index=0&id=53c41e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c41e0f",
  null
  
)

export default component.exports